import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { IoCloseSharp } from "react-icons/io5";
import Header from "../Header/Header";
import Menu from "../Manu/Menu";
import axios from "axios";
import { IoIosArrowForward } from "react-icons/io";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { storage } from "../../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useTranslation } from "react-i18next";
import { IoAddCircleOutline } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
import { FiUpload } from "react-icons/fi";
import { IoArrowDownCircleOutline, IoArrowUpCircleOutline } from "react-icons/io5";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://network.rentel.in";

const Add_click = () => {
  const { category, subcategory } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showCustomAddress, setShowCustomAddress] = useState(false);
  const [userAddress, setUserAddress] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const data = location.state || {};
  const product = data.product;
  const categoryId = data.categoryId;
  const isEditMode = data.isEditMode || false;

  const [amenity, setAmenity] = useState("");
  const [amenities, setAmenities] = useState([]);
  const [images, setImages] = useState([]);
  const [errors, setErrors] = useState({});

  /// amenities

  const handleAddAmenity = () => {
    if (amenity.trim() !== "" && !amenities.includes(amenity)) {
      setAmenities([...amenities, amenity]);
      setAmenity("");
    }
  };

  const handleRemoveAmenity = (item) => {
    setAmenities(amenities.filter((a) => a !== item));
  };


  /// Product FormData

  const [form, setForm] = useState({
    VenderName: "",
    title: "",
    description: "",
    price: "",
    fullAddress: "",
    area: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    size: "",
    rentType: "day",
    discount: 0,
    clothColor: "",
    fitType: "",
    material: "",
    sleeveLength: "",
    neckStyle: "",
    patternPrint: "",
    driver_type: "With vehicle",
    amenities: [],
    // Property fields
    propertyType: "",
    squareFootArea: "",
    noOfBedroom: "",
    noOfBathroom: "",
    furnishingStatus: "",
    ownershipType: "",
    propertyCondition: "",
    // Car fields
    carModel: "",
    color: "",
    carYear: "",
    bodyType: "",
    transmission: "",
    fuelType: "",
    mileage: "",
    driveTrain: "",
  });



  // useEffect(() => {
  //   // Only clear saved draft when NOT in edit mode
  //   if (!isEditMode) {
  //     localStorage.removeItem("editAd");
  //     localStorage.removeItem("tempFormData");
  //     sessionStorage.removeItem("isEditMode");
  //   }
  // }, [isEditMode]);



  // ✅ If editing, load the existing ad into the form

  useEffect(() => {
    // 🔒 Guard: logged-out (or expired token cleared) users should not access Add Product
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (product && isEditMode) {
      setForm((prevForm) => ({
        ...prevForm,
        title: product.title || "",
        description: product.description || "",
        price: product.price || "",
        fullAddress:
          product.location?.address ||
          product.userId?.fullAddress?.address ||
          product.fullAddress ||
          "",
        area: product.location?.area || product.area || "",
        city: product.location?.city || product.city || "",
        state:
          product.location?.state ||
          product.userId?.fullAddress?.state ||
          product.state ||
          "",
        country:
          product.location?.country ||
          product.userId?.fullAddress?.country ||
          product.country ||
          "",
        zipcode:
          product.location?.zipCode ||
          product.userId?.fullAddress?.zipCode ||
          product.zipcode ||
          "",
        rentType: product.rentType || "day",
        discount: product.discount || 0,
        size: product.size || "",
        clothColor: product.clothColor || "",
        fitType: product.fitType || "",
        material: product.material || "",
        sleeveLength: product.sleeveLength || "",
        neckStyle: product.neckStyle || "",
        patternPrint: product.patternPrint || "",
        // Property fields
        propertyType: product.propertyType || "",
        squareFootArea: product.squareFootArea || "",
        noOfBedroom: product.noOfBedroom || "",
        noOfBathroom: product.noOfBathroom || "",
        furnishingStatus: product.furnishingStatus || "",
        ownershipType: product.ownershipType || "",
        propertyCondition: product.propertyCondition || "",
        // Car fields
        carModel: product.carModel || "",
        color: product.color || "",
        driver_type: product.driver_type || "With vehicle",
        carYear: product.carYear || "",
        bodyType: product.bodyType || "",
        transmission: product.transmission || "",
        fuelType: product.fuelType || "",
        mileage: product.mileage || "",
        driveTrain: product.driveTrain || "",
      }));

      // Set images if they exist
      if (product.images && product.images.length > 0) {

        setImages(product.images);
      }

      // Set amenities if they exist
      if (product.amenities && product.amenities.length > 0) {
        setAmenities(product.amenities);
      }

      // Set custom address if location data exists
      if (product.location || product.fullAddress) {
        setShowCustomAddress(true);
      }
    }

    if (storedUser) {
      setForm((prevForm) => ({
        ...prevForm,
        VenderName: storedUser.name || "",
      }));
    }

    // console.log('Loading successfully.........');
  }, [isEditMode, navigate]);


  /// Add and Update Product Function

  const addAndUpdateProduct = async () => {

    // Step 1: Validation
    const isValid = validation();

    if (!isValid) {
      console.warn("Form validation failed, stopping submission.");
      return;
    }

    setIsSubmitting(true);

    try {
      let uploadedUrls = [];

      // Step 2: Filter new images

      const newImages = images.filter((img) => img instanceof File);


      // Step 3: Upload images if any
      if (newImages.length > 0) {

        try {
          uploadedUrls = await handleUploadImageOnFirebase(newImages);

        } catch (uploadErr) {
          console.error("Image upload failed (continuing without images):", uploadErr);
          uploadedUrls = [];
        }
      } else {
        uploadedUrls = images.filter((img) => typeof img === "string");

      }

      if (uploadedUrls.some((u) => typeof u === "string" && u.startsWith("blob:"))) {

        const blobUrls = uploadedUrls.filter((u) => typeof u === "string" && u.startsWith("blob:"));
        try {
          // console.log('error 2');
          const fetchedFiles = await Promise.all(
            blobUrls.map(async (url, i) => {
              const res = await fetch(url);
              const blob = await res.blob();
              const ext = (blob.type && blob.type.split("/")[1]) || "jpg";
              return new File([blob], `blob_${Date.now()}_${i}.${ext}`, { type: blob.type || "image/jpeg" });
            })
          );
          const uploadedFromBlobs = await handleUploadImageOnFirebase(fetchedFiles);
          uploadedUrls = [
            ...uploadedUrls.filter((u) => !(typeof u === "string" && u.startsWith("blob:"))),
            ...uploadedFromBlobs,
          ];

        } catch (blobErr) {
          console.error("Blob upload failed (continuing without blob images):", blobErr);
          uploadedUrls = uploadedUrls.filter((u) => typeof u === "string" && !u.startsWith("blob:"));
        }
      }

      uploadedUrls = uploadedUrls.filter(
        (u) => typeof u === "string" && /^https?:\/\//.test(u)
      );
      // reflect sanitized list in UI preview as well
      setImages(uploadedUrls);

      const currentUser = JSON.parse(localStorage.getItem("user"));
      const productData = {
        userId: currentUser?._id,
        VenderName: form.VenderName,
        title: form.title,
        description: form.description,
        categoryId,
        category,
        subCategory: subcategory || category || "General",
        rentType: form.rentType,
        price: form.price,
        discount: form.discount === '' ? "0" : form.discount,
        size: form.size,
        clothColor: form.clothColor,
        fitType: form.fitType,
        material: form.material,
        sleeveLength: form.sleeveLength,
        neckStyle: form.neckStyle,
        patternPrint: form.patternPrint,
        propertyType: form.propertyType,
        squareFootArea: form.squareFootArea,
        noOfBedroom: form.noOfBedroom,
        noOfBathroom: form.noOfBathroom,
        furnishingStatus: form.furnishingStatus,
        ownershipType: form.ownershipType,
        propertyCondition: form.propertyCondition,
        carModel: form.carModel,
        color: form.color,
        carYear: form.carYear,
        bodyType: form.bodyType,
        transmission: form.transmission,
        fuelType: form.fuelType,
        mileage: form.mileage,
        driver_type: form.driver_type,
        driveTrain: form.driveTrain,
        amenities,
        customAddress: showCustomAddress,
        location: showCustomAddress
          ? {
            address: form.fullAddress,
            area: form.area,
            city: form.city,
            state: form.state,
            country: form.country,
            zipCode: form.zipcode,
          }
          : {
            address: currentUser?.fullAddress?.address || currentUser?.address || userAddress || "",
            area: currentUser?.fullAddress?.area || currentUser?.area || "",
            city: currentUser?.fullAddress?.city || currentUser?.city || "",
            state: currentUser?.fullAddress?.state || currentUser?.state || "",
            country: currentUser?.fullAddress?.country || currentUser?.country || "",
            zipCode: currentUser?.fullAddress?.zipCode || currentUser?.zipCode || "",
          },
        images: uploadedUrls,
        compressedImages: uploadedUrls.length > 0 ? [uploadedUrls[0]] : [],
      };

      // console.log('product data ', productData);
      // Step 5: Check token
      const token = localStorage.getItem("token");
      if (!token) {
        // console.error("Authentication token missing!");
        alert("Authentication token missing. Please login again.");
        return;
      }

      const productId = isEditMode
        ? product._id
        : null;

      const endpoint = isEditMode
        ? `${API_BASE_URL}/products/edit?productId=${productId}`
        : `${API_BASE_URL}/products/add`;

      // console.log(endpoint);

      const response = isEditMode ? await axios.put(endpoint, productData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-auth-token": token,
          "Content-Type": "application/json",
        },
      }) :
        await axios.post(endpoint, productData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "x-auth-token": token,
            "Content-Type": "application/json",
          },
        });

      // console.log('Edit after product response ', response.data);

      // Step 8: Clean up and navigate
      localStorage.removeItem("editAd");
      sessionStorage.removeItem("isEditMode");

      // Navigate to home page after success
      navigate("/");

    } catch (error) {
      const serverStatus = error.response?.status;
      const serverData = error.response?.data;
      const serverMsg = serverData?.message || serverData?.msg || serverData?.error || null;
      console.error("🔥 Error submitting ad:", {
        message: error.message,
        status: serverStatus,
        data: serverData,
      });

      // ✅ Extra safe: token expired / unauthorized => auto logout and go to home (browse only)
      if (serverStatus === 401) {
        localStorage.clear();
        window.location.href = "/";
        return;
      }

      // Handle SSL/Network errors
      if (error.code === 'ERR_NETWORK' || error.code === 'ERR_SSL_VERSION_OR_CIPHER_MISMATCH' ||
        error.message?.includes('SSL') || error.message?.includes('secure connection')) {
        console.error("SSL/Network Error:", error.message);
        alert("Network connection error. Please check your internet connection or try again later.");
        return;
      }

      // Handle timeout errors
      if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
        alert("Request timeout. Please try again.");
        return;
      }

      alert(serverMsg ? `Submit failed: ${serverMsg}` : "Something went wrong while submitting the ad.");
    } finally {
      setIsSubmitting(false);
    }
  }


  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...form, [name]: value };
    setForm((prev) => ({ ...prev, [name]: value }));
    localStorage.setItem("tempFormData", JSON.stringify(updatedForm)); // ✅ auto-save
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    // Store actual File objects so we can upload directly to Firebase
    setImages((prevImages) => [...prevImages, ...files]);
  };

  // -- Rewritten to fix image functionality and handle Files and URLs robustly --
  const handleUploadImageOnFirebase = async (files) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?._id || "anonymous";
    // console.log('error 1');
    const uploadPromises = files.map(async (file, i) => {
      const safeName = file.name.replace(/\s+/g, "_");
      const filePath = `${userId}/products/${Date.now()}_${i}_${safeName}`;
      const imageRef = ref(storage, filePath);

      await uploadBytes(imageRef, file);
      return await getDownloadURL(imageRef);
    });

    return await Promise.all(uploadPromises);
  };


  const removeImage = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  const validation = () => {
    const newErrors = {};

    if (!form.title) newErrors.title = "Please enter ad title";
    if (!form.description) newErrors.description = "Please enter description";
    if (!form.price || isNaN(form.price))
      newErrors.price = "Please enter valid price";
    if (!form.description) newErrors.description = "Please enter description";
    // if (!form.discount) newErrors.discount = "Please enter discount";
    if (images.length === 0 && !isEditMode)
      newErrors.images = "Please upload at least one image";

    setErrors(newErrors);


    return Object.keys(newErrors).length === 0;
  };

  const handlePreviewSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!form.title) newErrors.title = "Please enter ad title";
    if (!form.description) newErrors.description = "Please enter description";
    if (!form.price || isNaN(form.price))
      newErrors.price = "Please enter valid price";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      // Prepare product data for preview
      const currentUser = JSON.parse(localStorage.getItem("user"));
      const previewProduct = {
        title: form.title,
        description: form.description,
        price: form.price,
        discount: form.discount || 0,
        category: category || "",
        subCategory: subcategory || category || "General",
        images: images, // Include both File objects and URLs
        size: form.size,
        clothColor: form.clothColor,
        fitType: form.fitType,
        material: form.material,
        sleeveLength: form.sleeveLength,
        neckStyle: form.neckStyle,
        patternPrint: form.patternPrint,
        propertyType: form.propertyType,
        squareFootArea: form.squareFootArea,
        noOfBedroom: form.noOfBedroom,
        noOfBathroom: form.noOfBathroom,
        furnishingStatus: form.furnishingStatus,
        ownershipType: form.ownershipType,
        propertyCondition: form.propertyCondition,
        carModel: form.carModel,
        color: form.color,
        carYear: form.carYear,
        bodyType: form.bodyType,
        transmission: form.transmission,
        fuelType: form.fuelType,
        mileage: form.mileage,
        driver_type: form.driver_type,
        driveTrain: form.driveTrain,
        amenities: amenities,
        rentType: form.rentType,
        location: showCustomAddress
          ? {
            address: form.fullAddress,
            area: form.area,
            city: form.city,
            state: form.state,
            country: form.country,
            zipCode: form.zipcode,
          }
          : {
            address: currentUser?.fullAddress?.address || currentUser?.address || userAddress || "",
            area: currentUser?.fullAddress?.area || currentUser?.area || "",
            city: currentUser?.fullAddress?.city || currentUser?.city || "",
            state: currentUser?.fullAddress?.state || currentUser?.state || "",
            country: currentUser?.fullAddress?.country || currentUser?.country || "",
            zipCode: currentUser?.fullAddress?.zipCode || currentUser?.zipCode || "",
          },
        userId: {
          name: currentUser?.name || form.VenderName || "Unknown Seller",
        },
      };

      // Navigate to Preview_Ad page with product data
      navigate("/Preview_Ad", { state: { product: previewProduct } });
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      const address = `${user?.address || ""}  ${user?.area || ""} ${user?.city || ""
        } ${user?.state || ""} ${user?.country || ""} ${user?.zipCode || ""}`;
      setUserAddress(address.trim());
    }
  }, []);

  return (
    <>
      {/* Green Loader Overlay */}
      {isSubmitting && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(173, 173, 173, 0.65)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            {[0, 1, 2, 3, 4].map((index) => (
              <div
                key={index}
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: "#E91E63",
                  animation: `bounce 1.4s ease-in-out ${index * 0.2}s infinite both`,
                }}
              />
            ))}
          </div>
          <style>
            {`
              @keyframes bounce {
                0%, 80%, 100% {
                  transform: scale(0);
                  opacity: 0.5;
                }
                40% {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            `}
          </style>
        </div>
      )}
      <NoZoomWrapper>
        <NoCopyWrapper>
          <Header />
          {/* <Menu /> */}
          <div className="container">

            <p className="breadcrumbee">
              <span
                className="breadcrumb-highlight"
                onClick={() => {
                  // Exit edit mode when going Home
                  sessionStorage.removeItem("isEditMode");
                  localStorage.removeItem("editAd");
                  localStorage.removeItem("tempFormData");
                  navigate("/");
                }}
              >
                Home
              </span>
              {category && (
                <span className="breadcrumbp">
                  {" "}
                  <IoIosArrowForward />{" "}
                  <span
                    className="breadcrumb-black"
                    onClick={() => navigate("/Add-product")}
                  >
                    {category}
                  </span>
                </span>
              )}
              {subcategory && (
                <span className="breadcrumbp">
                  {" "}
                  <IoIosArrowForward />{" "}
                  <span className="breadcrumb-black">{subcategory}</span>
                </span>
              )}
            </p>
            <div className="form-container">
              <h2 className="form-title">
                {isEditMode
                  ? t("editProduct") || "Edit Product"
                  : t("includeSomeDetails")}
              </h2>
              {/* Image Upload */}
              <div className="custom-upload-box" onClick={() => document.getElementById("image-upload").click()}>
                <div className="upload-iconf"><FiUpload /></div>

                <button className="browse-btn">Browse</button>

                <p className="drag-text">Drop a file here</p>

                <p className="file-support-text">
                  *File supported .png, .jpg & .webp
                </p>

                <input
                  id="image-upload"
                  type="file"
                  accept="image/*"
                  multiple
                  style={{ display: "none" }}
                  onChange={handleImageUpload}
                />
              </div>


              <div className="image-preview">
                {images.map((img, index) => (
                  <div className="image-box" key={index}>
                    <img src={typeof img === "string" ? img : URL.createObjectURL(img)} alt="Preview" className="preview-image" />
                    <span
                      className="close-btne"
                      onClick={() => removeImage(index)}
                    >
                      <IoCloseSharp />
                    </span>
                  </div>
                ))}
              </div>

              <form className="form" onSubmit={handlePreviewSubmit}>
                {/* Vendor Name */}
                <label>
                  {t("VenderName")}
                  <input
                    type="text"
                    value={form.VenderName || ""}
                    readOnly
                    className="readonly-input"
                  // placeholder="Vendor Name"
                  />
                </label>

                {/* Title */}
                <label>
                  {t("adTitle")}
                  <input
                    type="text"
                    name="title"
                    value={form.title}
                    onChange={handleChange}
                    placeholder={t("adTitlePlaceholder")}
                    required
                  />
                  {errors.title && (
                    <span className="error-message">{errors.title}</span>
                  )}
                </label>

                {/* Description */}
                <label>
                  {t("adDescription")}
                  <textarea
                    name="description"
                    value={form.description}
                    onChange={handleChange}
                    placeholder={t("adDescriptionPlaceholder")}
                    required
                  />
                  {errors.description && (
                    <span className="error-message">{errors.description}</span>
                  )}
                </label>

                {/* */}

                {/* Price and Discount and Rent Type*/}
                <div className="row">
                  <label style={{ flex: 1, position: "relative" }}>
                    {t("rentDuration")}

                    <div style={{ position: "relative" }}>
                      <select
                        name="rentType"
                        value={form.rentType}
                        onChange={handleChange}
                        required
                        className="custom-dropdown"
                        onFocus={() => setIsOpen(true)}
                        onBlur={() => setIsOpen(false)}
                        style={{ width: "100%", paddingRight: "35px" }}
                      >
                        <option value="day">day</option>
                        <option value="hour">hour</option>
                        <option value="week">week</option>
                        <option value="month">month</option>
                      </select>

                      {/* CUSTOM DROPDOWN ICON */}
                      <span
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          fontSize: 21,
                          color: "#d00",
                        }}
                      >
                        {isOpen ? <IoArrowUpCircleOutline /> : <IoArrowDownCircleOutline />}
                      </span>
                    </div>
                  </label>

                  <label style={{ flex: 1 }}>
                    {t("price")}
                    <input
                      type="text"
                      name="price"
                      value={form.price}
                      onChange={(e) => {
                        const onlyNums = e.target.value.replace(/[^0-9]/g, "");
                        setForm((prev) => ({ ...prev, price: onlyNums }));
                      }}
                      placeholder={t("pricePlaceholder")}
                      required
                    />
                  </label>

                  <label style={{ flex: 1, position: "relative" }}>
                    {t("discount")}
                    <input
                      type="text"
                      name="discount"
                      value={form.discount === 0 ? "" : form.discount}
                      onChange={(e) => {
                        const onlyNums = e.target.value.replace(/[^0-9]/g, "");
                        setForm((prev) => ({ ...prev, discount: onlyNums }));
                      }}
                      placeholder={t("discountPlaceholder")}
                    />
                    <span className="percentage-icon">%</span>
                    {errors.discount && (
                      <span className="error-message">{errors.discount}</span>
                    )}
                  </label>
                </div>
                {category === "Cloth" ? (
                  <>
                    <div className="row">
                      <label style={{ flex: 1 }}>
                        {t("size")}
                        <input
                          type="text"
                          name="size"
                          value={form.size}
                          onChange={handleChange}
                          placeholder={t("sizePlaceholder")}
                        />
                      </label>
                      <label style={{ flex: 1 }}>
                        {t("color")}
                        <input
                          type="text"
                          name="clothColor"
                          value={form.clothColor}
                          onChange={handleChange}
                          placeholder={t("colorPlaceholder")}
                        />
                      </label>
                      <label style={{ flex: 1 }}>
                        {t("fitType")}
                        <input
                          type="text"
                          name="fitType"
                          value={form.fitType}
                          onChange={handleChange}
                          placeholder={t("fitTypePlaceholder")}
                        />
                      </label>
                    </div>

                    <div className="row">
                      <label style={{ flex: 1 }}>
                        {t("sleeveLength")}
                        <input
                          type="text"
                          name="sleeveLength"
                          value={form.sleeveLength}
                          onChange={handleChange}
                          placeholder={t("sleeveLengthPlaceholder")}
                        />
                      </label>
                      <label style={{ flex: 1 }}>
                        {t("material")}
                        <input
                          type="text"
                          name="material"
                          value={form.material}
                          onChange={handleChange}
                          placeholder={t("materialPlaceholder")}
                        />
                      </label>

                      <label style={{ flex: 1 }}>
                        {t("patternPrint")}
                        <input
                          type="text"
                          name="patternPrint"
                          value={form.patternPrint}
                          onChange={handleChange}
                          placeholder={t("patternPrintPlaceholder")}
                        />
                      </label>
                    </div>

                    <div className="row">
                      <label className="custom-label">
                        {t("neckStyle")}
                        <input
                          type="text"
                          name="neckStyle"
                          value={form.neckStyle}
                          onChange={handleChange}
                          placeholder={t("neckStylePlaceholder")}
                        />
                      </label>

                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetailPlaceholder")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : category === "Property" ? (
                  <>
                    <div className="row">
                      <label className="custom-label">
                        {t("propertyType")}
                        <input
                          type="text"
                          name="propertyType"
                          value={form.propertyType}
                          onChange={handleChange}
                          placeholder={t("propertyTypePlaceholder")}
                        />
                      </label>
                      <label className="custom-label">
                        {t("squareFootArea")}
                        <input
                          type="text"
                          name="squareFootArea"
                          value={form.squareFootArea}
                          onChange={handleChange}
                          placeholder={t("squareFootAreaPlaceholder")}
                        />
                      </label>

                      <label className="custom-label">
                        {t("noOfBedroom")}
                        <input
                          type="text"
                          name="noOfBedroom"
                          value={form.noOfBedroom}
                          onChange={handleChange}
                          placeholder={t("noOfBedroomPlaceholder")}
                        />
                      </label>
                    </div>

                    <div className="row">
                      <label className="custom-label">
                        {t("noOfBathroom")}
                        <input
                          type="text"
                          name="noOfBathroom"
                          value={form["noOfBathroom"]}
                          onChange={handleChange}
                          placeholder={t("noOfBathroomPlaceholder")}
                        />
                      </label>
                      <label className="custom-label">
                        {t("furnishingStatus")}
                        <input
                          type="text"
                          name="furnishingStatus"
                          value={form["furnishingStatus"]}
                          onChange={handleChange}
                          placeholder={t("furnishingStatus")}
                        />
                      </label>

                      <label className="custom-label">
                        {t("ownershipType")}
                        <input
                          type="text"
                          name="ownershipType"
                          value={form["ownershipType"]}
                          onChange={handleChange}
                          placeholder={t("ownershipType")}
                        />
                      </label>
                    </div>

                    <div className="row-2">
                      <label className="custom-label">
                        {t("propertyCondition")}
                        <input
                          type="text"
                          name="propertyCondition"
                          value={form["propertyCondition"]}
                          onChange={handleChange}
                          placeholder={t("propertyCondition")}
                        />
                      </label>

                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetail")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : category === "Farm" ? (
                  <>
                    <div className="row">
                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetail")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : subcategory === "Car" ? (
                  <>
                    <div className="row">
                      <label className="custom-label">
                        {t("carModel")}
                        <input
                          type="text"
                          name="carModel"
                          value={form["carModel"]}
                          onChange={handleChange}
                          placeholder={t("carModelPlaceholder")}
                        />
                      </label>
                      <label className="custom-label">
                        {t("color")}
                        <input
                          type="text"
                          name="color"
                          value={form["color"]}
                          onChange={handleChange}
                          placeholder={t("colorPlaceholder")}
                        />
                      </label>

                      <label className="custom-label">
                        {t("carYear")}
                        <input
                          type="text"
                          name="carYear"
                          value={form["carYear"]}
                          onChange={handleChange}
                          placeholder={t("carYearPlaceholder")}
                        />
                      </label>
                    </div>

                    <div className="row">
                      <label className="custom-label">
                        {t("bodyType")}
                        <input
                          type="text"
                          name="bodyType"
                          value={form["bodyType"]}
                          onChange={handleChange}
                          placeholder={t("bodyTypePlaceholder")}
                        />
                      </label>
                      <label className="custom-label">
                        {t("transmission")}
                        <input
                          type="text"
                          name="transmission"
                          value={form["transmission"]}
                          onChange={handleChange}
                          placeholder={t("transmissionPlaceholder")}
                        />
                      </label>

                      <label className="custom-label">
                        {t("fuelType")}
                        <input
                          type="text"
                          name="fuelType"
                          value={form["fuelType"]}
                          onChange={handleChange}
                          placeholder={t("fuelTypePlaceholder")}
                        />
                      </label>
                    </div>

                    <div className="row">
                      <label className="custom-label">
                        {t("mileage")}
                        <input
                          type="text"
                          name="mileage"
                          value={form["mileage"]}
                          onChange={handleChange}
                          placeholder={t("mileagePlaceholder")}
                        />
                      </label>
                      <label className="custom-label">
                        {t("driveTrain")}
                        <input
                          type="text"
                          name="driveTrain"
                          value={form["driveTrain"]}
                          onChange={handleChange}
                          placeholder={t("driveTrainPlaceholder")}
                        />
                      </label>
                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetail")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : category === "Furniture" ? (
                  <>
                    <div className="row">
                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetail")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : category === "Driver" ? (
                  <>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <div className="row" style={{ width: "33%" }}>
                        <div className="bot-bio">
                          {" "}
                          <label className="custom-labelse">
                            {t("AddMoreDetail")}
                            <div className="amenities-input-box">
                              <input
                                type="text"
                                name="amenities"
                                value={amenity}
                                onChange={(e) => setAmenity(e.target.value)}
                                placeholder={t("AddMoreDetail")}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleAddAmenity();
                                  }
                                }}
                              />
                              <button
                                type="button"
                                className="add-btn"
                                onClick={handleAddAmenity}
                              >
                                <IoAddCircleOutline />
                              </button>
                            </div>
                          </label>
                          {/* Added Amenities */}
                          <div className="amenities-tags">
                            {amenities.map((item, index) => (
                              <span key={index} className="amenity-tag">
                                {item}
                                <button
                                  type="button"
                                  className="remove-btn"
                                  onClick={() => handleRemoveAmenity(item)}
                                >
                                  <RxCross2 className="remove-icone" />
                                </button>
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                      <label className="driver-type-label">
                        {t("DriverType")}
                        <select
                          name="driver_type"
                          value={form.driver_type}
                          onChange={handleChange}
                          required
                          className="driver-type-select"
                        >
                          <option value="with_vehicle">With vehicle</option>
                          <option value="without_vehicle">Without vehicle</option>
                          <option value="both">Both</option>
                        </select>
                      </label>
                    </div>
                  </>
                ) : category === "Clinic" ? (
                  <>
                    <div className="row">
                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetail")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : category === "Cleaning" ? (
                  <>
                    <div className="row">
                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetail")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : category === "Electronics" ? (
                  <>
                    <div className="row">
                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetail")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : category === "Machinery" ? (
                  <>
                    <div className="row">
                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetail")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div></>
                ) : category === "Camera" ? (
                  <>
                    <div className="row">
                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetail")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : subcategory === "Bike" ? (
                  <>
                    <div className="row">
                      <label className="custom-label">
                        {t("BikeModel")}
                        <input
                          type="text"
                          name="carModel"
                          value={form["carModel"]}
                          onChange={handleChange}
                          placeholder={t("BikeModelPlaceholder")}
                        />
                      </label>
                      <label className="custom-label">
                        {t("color")}
                        <input
                          type="text"
                          name="color"
                          value={form["color"]}
                          onChange={handleChange}
                          placeholder={t("colorPlaceholder")}
                        />
                      </label>

                      <label className="custom-label">
                        {t("BikeYear")}
                        <input
                          type="text"
                          name="carYear"
                          value={form["carYear"]}
                          onChange={handleChange}
                          placeholder={t("BikeYearPlaceholder")}
                        />
                      </label>
                    </div>

                    <div className="row">
                      <label className="custom-label">
                        {t("bodyType")}
                        <input
                          type="text"
                          name="bodyType"
                          value={form["bodyType"]}
                          onChange={handleChange}
                          placeholder={t("bodyTypePlaceholder")}
                        />
                      </label>
                      <label className="custom-label">
                        {t("transmission")}
                        <input
                          type="text"
                          name="transmission"
                          value={form["transmission"]}
                          onChange={handleChange}
                          placeholder={t("transmissionPlaceholder")}
                        />
                      </label>

                      <label className="custom-label">
                        {t("fuelType")}
                        <input
                          type="text"
                          name="fuelType"
                          value={form["fuelType"]}
                          onChange={handleChange}
                          placeholder={t("fuelTypePlaceholder")}
                        />
                      </label>
                    </div>

                    <div className="row">
                      <label className="custom-label">
                        {t("mileage")}
                        <input
                          type="text"
                          name="mileage"
                          value={form["mileage"]}
                          onChange={handleChange}
                          placeholder={t("mileagePlaceholder")}
                        />
                      </label>
                      <label className="custom-label">
                        {t("driveTrain")}
                        <input
                          type="text"
                          name="driveTrain"
                          value={form["driveTrain"]}
                          onChange={handleChange}
                          placeholder={t("driveTrainPlaceholder")}
                        />
                      </label>
                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetail")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : subcategory === "Truck" ? (
                  <>
                    <div className="row">
                      <label className="custom-label">
                        {t("truckModel")}
                        <input
                          type="text"
                          name="carModel"
                          value={form["carModel"]}
                          onChange={handleChange}
                          placeholder={t("truckModelPlaceholder")}
                        />
                      </label>
                      <label className="custom-label">
                        {t("color")}
                        <input
                          type="text"
                          name="color"
                          value={form["color"]}
                          onChange={handleChange}
                          placeholder={t("colorPlaceholder")}
                        />
                      </label>

                      <label className="custom-label">
                        {t("truckYear")}
                        <input
                          type="text"
                          name="carYear"
                          value={form["carYear"]}
                          onChange={handleChange}
                          placeholder={t("truckYearPlaceholder")}
                        />
                      </label>
                    </div>

                    <div className="row">
                      <label className="custom-label">
                        {t("bodyType")}
                        <input
                          type="text"
                          name="bodyType"
                          value={form["bodyType"]}
                          onChange={handleChange}
                          placeholder={t("bodyTypePlaceholder")}
                        />
                      </label>
                      <label className="custom-label">
                        {t("transmission")}
                        <input
                          type="text"
                          name="transmission"
                          value={form["transmission"]}
                          onChange={handleChange}
                          placeholder={t("transmissionPlaceholder")}
                        />
                      </label>

                      <label className="custom-label">
                        {t("fuelType")}
                        <input
                          type="text"
                          name="fuelType"
                          value={form["fuelType"]}
                          onChange={handleChange}
                          placeholder={t("fuelTypePlaceholder")}
                        />
                      </label>
                    </div>

                    <div className="row">
                      <label className="custom-label">
                        {t("mileage")}
                        <input
                          type="text"
                          name="mileage"
                          value={form["mileage"]}
                          onChange={handleChange}
                          placeholder={t("mileagePlaceholder")}
                        />
                      </label>
                      <label className="custom-label">
                        {t("driveTrain")}
                        <input
                          type="text"
                          name="driveTrain"
                          value={form["driveTrain"]}
                          onChange={handleChange}
                          placeholder={t("driveTrainPlaceholder")}
                        />
                      </label>
                      <div className="bot-bio">
                        {" "}
                        <label className="custom-labelse">
                          {t("AddMoreDetail")}
                          <div className="amenities-input-box">
                            <input
                              type="text"
                              name="amenities"
                              value={amenity}
                              onChange={(e) => setAmenity(e.target.value)}
                              placeholder={t("AddMoreDetail")}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAddAmenity();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="add-btn"
                              onClick={handleAddAmenity}
                            >
                              <IoAddCircleOutline />
                            </button>
                          </div>
                        </label>
                        {/* Added Amenities */}
                        <div className="amenities-tags">
                          {amenities.map((item, index) => (
                            <span key={index} className="amenity-tag">
                              {item}
                              <button
                                type="button"
                                className="remove-btn"
                                onClick={() => handleRemoveAmenity(item)}
                              >
                                <RxCross2 className="remove-icone" />
                              </button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : category === "Events" ? (
                  <>
                    <div className="bot-bio">
                      {" "}
                      <label className="custom-labelse">
                        {t("AddMoreDetail")}
                        <div className="amenities-input-box">
                          <input
                            type="text"
                            name="amenities"
                            value={amenity}
                            onChange={(e) => setAmenity(e.target.value)}
                            placeholder={t("AddMoreDetail")}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                handleAddAmenity();
                              }
                            }}
                          />
                          <button
                            type="button"
                            className="add-btn"
                            onClick={handleAddAmenity}
                          >
                            <IoAddCircleOutline />
                          </button>
                        </div>
                      </label>
                      {/* Added Amenities */}
                      <div className="amenities-tags">
                        {amenities.map((item, index) => (
                          <span key={index} className="amenity-tag">
                            {item}
                            <button
                              type="button"
                              className="remove-btn"
                              onClick={() => handleRemoveAmenity(item)}
                            >
                              <RxCross2 className="remove-icone" />
                            </button>
                          </span>
                        ))}
                      </div>
                    </div>
                  </>
                ) : null}

                <div
                  className="custom-toggle-wrapper"
                  onClick={() => setShowCustomAddress(!showCustomAddress)}
                >
                  <div
                    className={`toggle-switch ${showCustomAddress ? "active" : ""
                      }`}
                  ></div>
                  <span className="toggle-label-text">
                    {t("setCustomAddress")}
                  </span>
                </div>
                {!showCustomAddress && (
                  <div className="default-address">
                    <span role="img" aria-label="location">
                      <HiOutlineLocationMarker />
                    </span>{" "}
                    <span>{userAddress}</span>
                  </div>
                )}

                {/* Full Address */}
                {showCustomAddress && (
                  <>
                    {/* Full Address */}
                    <label>
                      {t("fullAddress")}
                      <textarea
                        name="fullAddress"
                        value={form.fullAddress}
                        onChange={handleChange}
                        placeholder={t("fullAddressPlaceholder")}
                        required
                      />
                      {errors.fullAddress && (
                        <span className="error-message">
                          {errors.fullAddress}
                        </span>
                      )}
                    </label>

                    {/* Area */}
                    <label>
                      {t("nameOfArea")}
                      <input
                        type="text"
                        name="area"
                        value={form.area}
                        onChange={handleChange}
                        placeholder={t("nameOfAreaPlaceholder")}
                        required
                      />
                      {errors.area && (
                        <span className="error-message">{errors.area}</span>
                      )}
                    </label>

                    <div className="row">
                      <label style={{ flex: 1 }}>
                        {t("city")}
                        <input
                          type="text"
                          name="city"
                          value={form.city}
                          onChange={handleChange}
                          placeholder={t("cityPlaceholder")}
                          required
                        />
                        {errors.city && (
                          <span className="error-message">{errors.city}</span>
                        )}
                      </label>
                      <label style={{ flex: 1 }}>
                        {t("state")}
                        <input
                          type="text"
                          name="state"
                          value={form.state}
                          onChange={handleChange}
                          placeholder={t("statePlaceholder")}
                          required
                        />
                        {errors.state && (
                          <span className="error-message">{errors.state}</span>
                        )}
                      </label>
                    </div>

                    <div className="row">
                      <label style={{ flex: 1 }}>
                        {t("country")}
                        <input
                          type="text"
                          name="country"
                          value={form.country}
                          onChange={handleChange}
                          placeholder={t("countryPlaceholder")}
                          required
                        />
                        {errors.country && (
                          <span className="error-message">
                            {errors.country}
                          </span>
                        )}
                      </label>
                      <label style={{ flex: 1 }}>
                        {t("zipcode")}
                        <input
                          type="text"
                          name="zipcode"
                          value={form.zipcode}
                          onChange={(e) => {
                            const onlyNums = e.target.value.replace(/\D/g, "");
                            setForm((prev) => ({ ...prev, zipcode: onlyNums }));
                          }}
                          placeholder={t("zipcodePlaceholder")}
                          required
                        />
                        {errors.zipcode && (
                          <span className="error-message">
                            {errors.zipcode}
                          </span>
                        )}
                      </label>
                    </div>
                  </>
                )}

                {/* Buttons */}
                <div className="button-group">
                  <button
                    type="button"
                    className="sell-btnee"
                    onClick={addAndUpdateProduct}
                  >
                    {isEditMode
                      ? t("updateProduct") || "Update Product"
                      : t("sellFasterNow")}
                  </button>
                  {/* <button type="submit" className="preview-btnee">
                    {t("previewAd")}
                  </button> */}
                </div>
              </form>
            </div>
          </div>
        </NoCopyWrapper >
      </NoZoomWrapper >
    </>
  );
};

export default Add_click;